export enum QuestionValidationOption {
  CORRECT,
  WRONG,
}

export enum QuestionType {
  BOOLEAN,
  SELECTION,
}

export interface QuestionOption {
  title: string;
  value: string;
  validation: QuestionValidationOption;
}

interface Question {
  order: number;
  translationTitle: string;
  type: QuestionType;
  options: Array<QuestionOption>;
  name: string;
  page: number;
}

const question1: Question = {
  order: 1,
  translationTitle: 'KnowledgeTest.question1',
  type: QuestionType.BOOLEAN,
  name: 'isAOVBefore',
  page: 1,
  options: [{
    title: 'Yes',
    value: 'Yes',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'No',
    value: 'No',
    validation: QuestionValidationOption.CORRECT
  }]
};

const question2: Question = {
  order: 2,
  translationTitle: 'KnowledgeTest.question2',
  type: QuestionType.BOOLEAN,
  name: 'isAdvisorHelp',
  page: 1,
  options: [{
    title: 'Yes',
    value: 'Yes',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'No',
    value: 'No',
    validation: QuestionValidationOption.CORRECT
  }]
};

const question3: Question = {
  order: 3,
  translationTitle: 'KnowledgeTest.question3',
  type: QuestionType.SELECTION,
  name: 'benefitDurationChoice',
  page: 1,
  options: [{
    title: 'KnowledgeTest.question3option1',
    value: 'BEST_FITS',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question3option2',
    value: 'LONGEST',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question3option3',
    value: 'SHORT',
    validation: QuestionValidationOption.WRONG
  }]
};

const question4: Question = {
  order: 4,
  translationTitle: 'KnowledgeTest.question4',
  type: QuestionType.SELECTION,
  name: 'consequencesOfDisability',
  page: 1,
  options: [{
    title: 'KnowledgeTest.question4option1',
    value: 'I_KNOW_COSTS',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question4option2',
    value: 'KNOW_APPROXIMATELY',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question4option3',
    value: 'DONT_KNOW',
    validation: QuestionValidationOption.WRONG
  }]
};

const question5: Question = {
  order: 5,
  translationTitle: 'KnowledgeTest.question5',
  type: QuestionType.SELECTION,
  name: 'monthlyAmount',
  page: 1,
  options: [{
    title: 'KnowledgeTest.question5option1',
    value: 'MAX',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question5option2',
    value: 'NEEDED',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question5option3',
    value: 'RANDOM',
    validation: QuestionValidationOption.WRONG
  }]
};

const question6: Question = {
  order: 6,
  translationTitle: 'KnowledgeTest.question6',
  type: QuestionType.SELECTION,
  name: 'productInformation',
  page: 2,
  options: [{
    title: 'KnowledgeTest.question6option1',
    value: 'READ',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question6option2',
    value: 'DONT_UNDERSTAND',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question6option3',
    value: 'DONT_READ',
    validation: QuestionValidationOption.WRONG
  }]
};

const question7: Question = {
  order: 7,
  translationTitle: 'KnowledgeTest.question7',
  type: QuestionType.SELECTION,
  name: 'benefitsWithDeductiblePeriod',
  page: 2,
  options: [{
    title: 'KnowledgeTest.question7option1',
    value: 'IMMEDIATELY',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question7option2',
    value: 'MORE_THAN_DEDUCTIBLE_PERIOD',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question7option3',
    value: 'IMMEDIATELY_AND_KEEP_PAYING',
    validation: QuestionValidationOption.WRONG
  }]
};

const question8: Question = {
  order: 8,
  translationTitle: 'KnowledgeTest.question8',
  type: QuestionType.SELECTION,
  name: 'benefitLimit25',
  page: 2,
  options: [{
    title: 'KnowledgeTest.question8option1',
    value: 'NO_MONTHLY_BENEFIT',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question8option2',
    value: '20_INSURED_AMOUNT',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question8option3',
    value: '25_SUM_INSURED',
    validation: QuestionValidationOption.WRONG
  }]
};

const question9: Question = {
  order: 9,
  translationTitle: 'KnowledgeTest.question9',
  type: QuestionType.SELECTION,
  name: 'insuredAmountAdjustment',
  page: 2,
  options: [{
    title: 'KnowledgeTest.question9option1',
    value: 'YES',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question9option2',
    value: 'NO',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question9option3',
    value: 'DONT_KNOW',
    validation: QuestionValidationOption.WRONG
  }]
};

const question10: Question = {
  order: 10,
  translationTitle: 'KnowledgeTest.question10',
  type: QuestionType.SELECTION,
  name: 'activitiesChange',
  page: 3,
  options: [{
    title: 'KnowledgeTest.question10option1',
    value: 'NOTHING',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question10option2',
    value: 'REPORT_MUCH',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question10option3',
    value: 'REPORT_ALWAYS',
    validation: QuestionValidationOption.CORRECT
  }]
};

const question11: Question = {
  order: 11,
  translationTitle: 'KnowledgeTest.question11',
  type: QuestionType.SELECTION,
  name: 'maxAmountIfCosts2500',
  page: 3,
  options: [{
    title: 'KnowledgeTest.question11option1',
    value: '80_PERCENTAGE',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question11option2',
    value: 'UP_TO_2500',
    validation: QuestionValidationOption.WRONG
  }, {
    title: 'KnowledgeTest.question11option3',
    value: '2500_ADDITIONAL_750',
    validation: QuestionValidationOption.CORRECT
  }]
};

const question12: Question = {
  order: 12,
  translationTitle: 'KnowledgeTest.question12',
  type: QuestionType.SELECTION,
  name: 'awareOfApplying',
  page: 3,
  options: [{
    title: 'KnowledgeTest.question12option1',
    value: 'CONVINCED',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question12option2',
    value: 'STUDIED',
    validation: QuestionValidationOption.CORRECT
  }, {
    title: 'KnowledgeTest.question12option3',
    value: 'HAVE_TO_PAY',
    validation: QuestionValidationOption.WRONG
  }]
};

export const KnowledgeTestQuestions: Array<Question> = [
  question1,
  question2,
  question3,
  question4,
  question5,
  question6,
  question7,
  question8,
  question9,
  question10,
  question11,
  question12,
];

